import React from 'react'
import "./pay.css";

const Paynow = () => {
  return (
    <>
    
  

  <section className="section">
    <h2 style={{ marginBottom: 30, color: "#e65100" }}>
      💡 Why Choose ICICI Pay?
    </h2>
    <div className="features">
      <div className="card">
        <h3>🔒 Secure Gateway</h3>
        <p>
          End-to-end encryption ensures your transactions are safe with
          bank-level security.
        </p>
      </div>
      <div className="card">
        <h3>⚡ Instant Transfers</h3>
        <p>
          Make real-time payments with UPI, NetBanking, or Card without delays.
        </p>
      </div>
      <div className="card">
        <h3>📱 Mobile Ready</h3>
        <p>Optimized for mobile, so you can pay on-the-go anytime, anywhere.</p>
      </div>
    </div>
  </section>
  
    </>
  )
}

export default Paynow
